import { FC, forwardRef, CSSProperties } from 'react';
import classNames from 'classnames/bind';
import { SkeletonType, SkeletonClass } from './types/enums';
import { SkeletonFramePropsTypes } from './types/propsType';
import styles from './SkeletonFrame.module.scss';

const cx = classNames.bind(styles);

/**
 * @description SkeletonFrame component .
 * Props ->
 * heightValue(string): height of the block (px),
 * widthValue(string): width of the block (px),
 * borderRadiusValue(string): borderRadius of the block (px),
 * isRoundCorner(boolean): to show/hide round edges,
 * type(SkeletonType): Predefined block
 *     'FULL_WIDTH', 'IMAGE_PANEL', 'BUTTON',
 */

const SkeletonFrame: FC<SkeletonFramePropsTypes> = forwardRef<HTMLDivElement, SkeletonFramePropsTypes>(
  (
    {
      heightValue,
      widthValue,
      borderRadiusValue,
      isRoundCorner,
      type = SkeletonType.FULL_WIDTH,
      className,
    }: SkeletonFramePropsTypes,
    ref,
  ) => {
    const style: CSSProperties = {};

    if (heightValue) {
      style.height = `${heightValue}px`;
    }
    if (widthValue) {
      style.width = `${widthValue}px`;
    }
    if (borderRadiusValue) {
      style.borderRadius = isRoundCorner ? `${borderRadiusValue}px` : '0px';
    }
    const CClassname = cx('skeleton', [SkeletonClass[type]], className);
    return <div className={CClassname} data-testid="skeleton-frame" style={style} ref={ref}></div>;
  },
);
SkeletonFrame.displayName = 'SkeletonFrame';
export default SkeletonFrame;
export { SkeletonType };
